import { TwinEmployeeParametersDict } from '@teinor/erp/types/company/userInner/employeeParameter'
import { ButtonRedSecondary, ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import { LittleModalCreateEditOutside } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalDeleteFilledOutside } from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { TwinParameters } from '@teinor/erp/types/company/config/parameter'
import useEditDeleteModal, { SetEditDeleteModalTy } from '../../../../../../../../utils/hooks/useEditDeleteModal'
import { Fragment } from 'react'
import { WorkingCenterPayload } from '../../../../../../../../utils/reducers/company/workingCenters'
import { SpecificPriceRulesPayload } from '../../../../../../../../utils/reducers/products/specificPriceRules'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../../utils/hoc/withLoading'

interface ConfigPrestashopCustomRenderProps {
    parameters: TwinParameters
    getData: () => Promise<void>
}

export const ConfigPrestashopCustomRender: React.FC<ConfigPrestashopCustomRenderProps> = ({ parameters, getData }) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    let myRender = <ConfigurePrestashop setOpenModal={setOpenModal} />
    if (parameters?.prestashopApi) {
        myRender = <ConfiguratedPrestashop setOpenModal={setOpenModal} />
    }
    return (
        <Fragment>
            {myRender}
            {openModal?.type === 'edit' ? <ModalPrestashopParametersConfigConnect onSubmit={getData} setOpened={() => setOpenModal(null)} /> : null}
            {openModal?.type === 'delete' ? <ModalDeletePrestashopConfigQuote onSubmit={getData} setOpened={() => setOpenModal(null)} /> : null}
        </Fragment>
    )
}

interface ConfiguratedPrestashopProps {
    setOpenModal: SetEditDeleteModalTy
}

const ConfiguratedPrestashop: React.FC<ConfiguratedPrestashopProps> = ({ setOpenModal }) => {
    return (
        <div className='gap-10 flex flex-row items-center'>
            <div className='flex gap-x-5'>
                <TwinTrans transKey={'prestashopConfigured'}>Prestashop configurado</TwinTrans>
            </div>
            <ButtonRedSecondary className='w-fit ml-10' type='button' onClick={() => setOpenModal({ type: 'delete', allRowData: {} })} key={'deletePrestashopConfig'}><TwinTrans transKey={'deletePrestashopConfig'}>Borrar configuración de prestashop</TwinTrans></ButtonRedSecondary>
        </div>
    )
}

interface ConfigurePrestashopProps {
    setOpenModal: SetEditDeleteModalTy
}
const ConfigurePrestashop: React.FC<ConfigurePrestashopProps> = ({ setOpenModal }) => {
    return (
        <div className='gap-10 flex flex-row items-center'>
            <span><TwinTrans transKey={'prestashopParametersConfig'}>Configurar parámetros de prestashop</TwinTrans>:</span>
            <ButtonSecondary className='w-fit' type='button' onClick={() => setOpenModal({ type: 'edit', allRowData: {} })} key={'configPrestashop'}><TwinTrans transKey={'Config'}>Configurar</TwinTrans></ButtonSecondary>
        </div>
    )
}

interface ModalDeletePrestashopConfigQuoteProps extends ModalEditComponentProps { }

const ModalDeletePrestashopConfigQuote: React.FC<ModalDeletePrestashopConfigQuoteProps> = ({ setOpened, onSubmit }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/config/parameter/deleteParameters',
        data: {
            parameters: ['prestashopApi', 'prestashopSite']
        }
    })

    return (
        <ModalDeleteFilledOutside opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeletePrestashopConfig', '¿Seguro que quieres borrar la configuración de prestashop?'),
            subtitle: t('YouWillBeAbleToConfigItAgain', 'Podrás volver a configurarla de nuevo'),
            buttonAccept: t('delete', 'Borrar'),
        }} />
    )
}

interface ModalPrestashopParametersConfigProps extends ModalEditComponentProps { }

const ModalPrestashopParametersConfig: React.FC<ModalPrestashopParametersConfigProps & ReduxModalPrestashopParametersConfigConnector> = ({ setOpened, onSubmit, workingCenters, specificPriceRules }) => {
    const { t } = useTwinTranslation()
    const fields: FormRender<TwinEmployeeParametersDict> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'prestashopApi',
                    label: t('prestashopApi', 'Api de Prestashop'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'prestashopSite',
                    label: t('prestashopUrl', 'URL de Prestashop'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'prestashopWorkingCenterId',
                    label: t('prestashopWorkingCenterId', 'Centro de Prestashop'),
                    component: 'CustomSelectWithSearchBar',
                    items: workingCenters || {},
                    required: true
                },
                {
                    name: 'prestashopSpecificRuleId',
                    label: t('prestashopSpecificRuleId', 'Precios de Prestashop'),
                    component: 'CustomSelectWithSearchBar',
                    items: specificPriceRules?.dictionary || {},
                    required: true
                },
            ]
        },
    ]
    return (
        <LittleModalCreateEditOutside className={'flex flex-col'} fields={fields} setOpened={setOpened} url={'/api/app/config/parameter/updateParameters'} translations={{
            title: t('parameters', 'Parámetros'),
            button: t('save', 'Guardar')
        }} haveButtonPermissions={true} onSubmit={onSubmit} />
    )
}

const modalPrestashopParametersConfigDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}
const mapModalPrestashopParametersConfigConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters, specificPriceRules: state.specificPriceRules })
const modalPrestashopParametersConfigConnector = connect(mapModalPrestashopParametersConfigConnector, modalPrestashopParametersConfigDispatch)
type ReduxModalPrestashopParametersConfigConnector = ConnectedProps<typeof modalPrestashopParametersConfigConnector>

const modalPrestashopParametersConfigConnectLoading = withLoading(ModalPrestashopParametersConfig, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])

const ModalPrestashopParametersConfigConnect = modalPrestashopParametersConfigConnector(modalPrestashopParametersConfigConnectLoading)